import { UtilityService } from "@ecap3/core";
export class DriveFolder {
    public ParentId : string;
    public IsFavorite:boolean;
    public OwnerName: string;
    public SharedByUserName: string;
    public ItemId: string;
    public Name: string;
    public Description:string
    public Color: string;
    public CreateDate: any;
    public OrganizationId?: string;
    public OriginalObjectArtifactId: string;
    public Type: any;
    public Secured: boolean;
    public SharedUserIdList:string[];
    public SharedRoleList:string[];
    public IsPublished: boolean;
    public IsArchived: boolean;
    sharedToUserId: string;
    OwnerId: string;
    constructor(
        ParentId : string,
        IsFavorite:boolean,
        OwnerName: string,
        SharedByUserName: string,
        sharedToUserId: string,
        OwnerId: string,
        OrganizationId: string,
        ItemId: string,
        Name: string,
        Description:string,
        Color: string,
        CreateDate: any,
        SharedUserIdList:string[],
        SharedRoleList:string[],
        OriginalObjectArtifactId?: any,
        Type?: string,
        IsPublished?: boolean,
        IsArchived?: boolean,
        private utilityService?: UtilityService
    ) {
        this.ParentId = ParentId;
        this.IsFavorite=IsFavorite;
        this.OwnerName = OwnerName;
        this.SharedByUserName = SharedByUserName;
        this.sharedToUserId = sharedToUserId;
        this.OwnerId = OwnerId;
        this.OrganizationId = OrganizationId;
        this.ItemId = ItemId || this.utilityService.getNewGuid();
        this.Name = Name;
        this.Description = Description;
        this.Color = Color;
        this.CreateDate = CreateDate;
        this.SharedUserIdList = SharedUserIdList||[];
        this.SharedRoleList = SharedRoleList||[];
        this.OriginalObjectArtifactId = OriginalObjectArtifactId;
        this.Type = Type || "DriveFolder";
        this.IsArchived = IsArchived || false;
        this.IsPublished = IsPublished || false;
    }
}